export const cpscRefFragment = `
  fragment cpscRefFields on UsCpscPgaProgram {
    items {
      itemType
      description
      productRegistryReference {
        productId
        versionId
        certifierId
      }
    }
  }
`;
